<nav class="navbar navbar-expand-xl boxshadow fixed-top">
  <a class="navbar-brand" routerLink="/">
    <span>
      <img class="logo" src="./assets/images/logo_new.png" />
    </span>
  </a>
  <button class="navbar-toggler" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>

  <div
    id="wwtp"
    class="collapse navbar-collapse"
    [ngbCollapse]="isMenuCollapsed">
    <ul class="navbar-nav ms-auto" style="margin-top: -4px">
      <ng-container *ngIf="showLinks">
        <li class="nav-item mt-14px" *ngFor="let link of links$ | async; index as i">
          <a
            class="nav-link text-white cursor-pointer"
            (click)="onLinkClick(i)">
            {{ link.linkText }}
          </a>
        </li>
      </ng-container>

      <!-- <li class="nav-item mt-14px">
        <a
          class="nav-link text-white"
          id="static"
          role="button"
          routerLink="/mixdashboard/mix-report-list">
          All Report
        </a>
      </li> -->
      <li class="nav-item mt-14px">
        <a
          class="nav-link text-white"
          routerLink="/report-system/dashboard-group-list"
          [queryParams]="{ type: 'executive' }">
          All Report        </a>
      </li>
      <li class="nav-item notification-nav-item mt-14px">
        <a class="nav-link notification-link text-white" (click)="toggleNotificationPanel()" title="Notifications" style="cursor: pointer;">
          <i class="fa fa-bell notification-icon"></i>
          <span *ngIf="unreadNotificationCount > 0" class="notification-badge">{{ unreadNotificationCount }}</span>
        </a>
      </li>
      <li class="nav-item ml-1" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="userauth" role="button">
          <img
            [src]="imageSrc || './assets/images/avathar.jpg'"
            height="40"
            style="border-radius: 50%; margin-top: -8px; height: 35px"
            alt="User avatar" />
        </a>
        <ul
          ngbDropdownMenu
          aria-labelledby="userauth"
          class="dropdown-menu bg-light top-52px logout shadow user-menus">
          <li ngbDropdown placement="left">
            <a
              *ngIf="!visitedUserManagementSites"
              class="sub-dropdown"
              id="library"
              (click)="logout()"
              ngbDropdownToggle
              ><i class="fa fa-power-off"></i> Logout
            </a>
            <span *ngIf="visitedUserManagementSites" class="sub-dropdown text-muted"
              style="cursor:not-allowed;user-select:none; margin-right: 80px; padding-left: 2px;">
              <i class="fa fa-ban"></i> You can't <br>logout from here
            </span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<!-- Notification Panel Backdrop -->
<div 
  *ngIf="isNotificationPanelOpen" 
  class="notification-backdrop"
  (click)="onBackdropClick($event)">
</div>

<!-- Notification Panel -->
<div 
  class="notification-panel"
  [class.open]="isNotificationPanelOpen"
  [class.dark-mode]="isDarkMode">
  <div class="notification-panel-header">
    <h4 class="notification-panel-title">
      <i class="fa fa-bell"></i> Notifications
      <span *ngIf="unreadNotificationCount > 0" class="badge badge-danger unread-badge-panel">
        {{ unreadNotificationCount }}
      </span>
    </h4>
    <div class="notification-panel-actions">
      <div class="theme-switch-container">
        <label class="theme-switch-label">
          <i class="fa fa-sun" [class.active]="!isDarkMode"></i>
          <input 
            type="checkbox" 
            class="theme-switch"
            [checked]="isDarkMode"
            (change)="onThemeToggle()"
            title="Toggle Dark/Light Mode">
          <span class="theme-switch-slider"></span>
          <i class="fa fa-moon" [class.active]="isDarkMode"></i>
        </label>
      </div>
      <button class="btn btn-sm btn-close-panel" (click)="closeNotificationPanel()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <div class="notification-panel-content">
    <app-notification-list 
      #notificationListComponent
      [class.dark-mode]="isDarkMode"
      (notificationClicked)="closeNotificationPanel()">
    </app-notification-list>
  </div>
</div>
